import React, { forwardRef } from 'react';

import { Icon } from 'Icon';

import { LinkProps } from './Link.types';
import { StyledLink } from './Link.styled';

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ iconPosition = 'leading', icon, children, ...props }: LinkProps, ref) => {
    return (
      <StyledLink {...props} ref={ref}>
        {icon && iconPosition === 'leading' && <Icon icon={icon} />}
        {children}
        {icon && iconPosition === 'trailing' && <Icon icon={icon} />}
      </StyledLink>
    );
  },
);
Link.displayName = 'Link';
